export default __webpack_public_path__ + "static/media/oggi5.6e9951a6.jpg";